import React, { FC } from 'react';
import { DropZoneOverlay } from './DropZoneOverlay';
import { useCsvFileDrop } from './use-csv-file-drop.hook';
import { useImportKalkylFile } from './use-import-kalkyl-file.hook';

/**
 * Window-level CSV drag/drop for the Build view. Uploads the dropped file,
 * parks the new file under the list chrome, and switches to the Import tab
 * via {@link onImported}.
 */
export const BuildViewCsvDropZone: FC<{
  onImported?: (importId: string) => void;
}> = ({ onImported }) => {
  const { importFile, reportInvalidFile } = useImportKalkylFile({ onImported });

  const { dragState } = useCsvFileDrop({
    onImport: importFile,
    onInvalidFile: reportInvalidFile,
  });

  return <DropZoneOverlay state={dragState} />;
};
